import { waLink, track } from "@/constants/site";
import Reveal from "@/components/base/Reveal";

export default function B2BBlock() {
  return (
    <section className="relative overflow-hidden bg-primary-950">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(115deg, oklch(var(--primary-400)) 0, oklch(var(--primary-400)) 1px, transparent 1px, transparent 46px)",
        }}
      />
      <div className="relative mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <h2 className="font-heading text-3xl font-extrabold leading-tight tracking-tight text-background-50 md:text-4xl">
              Motor parado pode significar produção parada.
            </h2>
            <p className="mt-4 max-w-lg text-base leading-relaxed text-background-100/80 md:text-lg">
              Quando um equipamento essencial apresenta falha, cada decisão importa. Fale com
              a Power, explique a necessidade e descubra o próximo passo adequado para sua
              operação.
            </p>
            <a
              href={waLink("Olá! Preciso de atendimento técnico para um equipamento parado.")}
              target="_blank"
              rel="noreferrer"
              onClick={() => track("whatsapp_click")}
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-accent-600"
            >
              Solicitar atendimento técnico
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </Reveal>

          <Reveal delay={120}>
            <div className="relative overflow-hidden rounded-lg border border-background-50/15">
              <img
                src="https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/1e1fa86a-b563-4a80-a0d4-d14a72926ab2_compressed_powermotoreseletricos-7.webp"
                alt="Motor elétrico WEG industrial com placa de identificação"
                title="Motor elétrico WEG industrial - Power Motores Elétricos"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}